import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { StyledCategoryDropDown } from './styles/StyledCategoryDropDown';


class CategoryDropDown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };

    this.onClickCategory = this.onClickCategory.bind(this);
  }

  onClickCategory() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  handleKeyDown(keyCode){
    if(keyCode === 13 && !this.state.isOpen){
      this.onClickCategory();
    }
  }

  render() {
    const { title, children, } = this.props;
    const { isOpen } = this.state;

    return (
      <StyledCategoryDropDown
        isOpen={isOpen}
        role="button"
        aria-pressed={isOpen ? "true" : "false"}
        aria-expanded={isOpen ? "true" : "false"}
        tabIndex="0"
        onClick={this.onClickCategory}
        onKeyDown={(e) => this.handleKeyDown(e.keyCode)}
      >  
        <div className="category-dd-title-wrapper">
          <table className="category-dd-table"
          >
            <tbody>
              <tr>
                <td>
                  <div className="category-dd-title">
                    { title }
                  </div>
                </td>
                <td className="category-dd-arrow">
                  <i className={isOpen ? "fa fa-angle-down" : "fa fa-angle-right" } aria-hidden="true"></i>
                </td>
              </tr>
            </tbody>
          </table>    
        </div>
          
          {isOpen &&
            <div className="category-dd-items"
              key="category-dd-items"
              aria-expanded={isOpen ? "true" : "false"}
            >
              {
                children
              }
            </div>
          }
          
        
      </StyledCategoryDropDown>
    );
  }
}


CategoryDropDown.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired,
};


export default CategoryDropDown;